/* @flow */

import api from '../utils/api';
import MontarWidgetTotais from './components/MontarWidgetTotais';
import exibirErro from '../utils/exibir-erro';
import {
    type TotaisEtapas,
    type TotaisEtapasRetornoApi,
    type IntervaloData,
} from './types';
import { COR_ETAPA } from '../atendimento/constants';

const adicionarChavesView = (
    etapas: TotaisEtapasRetornoApi[],
    valorTotal: number,
): TotaisEtapas[] => {
    const totaisEtapas = etapas.map(totalEtapa => ({
        ...totalEtapa,
        cor: COR_ETAPA[totalEtapa.etapasId],
        porcentagem: totalEtapa.valor / valorTotal * 100,
    }));

    const etapaTotal = {
        valor: valorTotal,
        contagem: etapas.reduce((acc, etapa) => acc + etapa.contagem, 0),
        etapasId: 0,
        etapa: 'Total de pedidos',
        cor: 'accent',
        porcentagem: 100,
    };

    return [etapaTotal, ...totaisEtapas];
};

const calcularTotais = async (intervalo: IntervaloData) => {
    try {
        const { data } = await api.getTotaisPorEtapa(intervalo);
        const valorTotal = data.reduce((acc, totalEtapa) => acc + totalEtapa.valor, 0);
        const etapasOrdemCorreta = adicionarChavesView(data, valorTotal);
        MontarWidgetTotais(etapasOrdemCorreta);
    } catch (err) {
        exibirErro(err);
    }
};

export default calcularTotais;
